import { inject } from '@angular/core';
import { CanActivateFn, CanActivateChildFn, Router } from '@angular/router';
import { AuthState } from 'app/core/state/auth.state';

/**
 * Guard that blocks non-Demo users from accessing /demo routes.
 *
 * ROLE ACCESS:
 * - Demo: ✅
 * - Others: ❌ → redirect to their default route
 */
export const DemoGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  const router = inject(Router);
  const authState = inject(AuthState);

  if (!authState.hasDemoAccess()) {
    console.log('[DemoGuard] Access denied - redirecting to:', authState.defaultRoute());
    router.navigate([authState.defaultRoute()]);
    return false;
  }

  return true;
};
